import axios from "axios";
import { installApiLogger } from "./apiLog";

// Colony portal axios — completely separate from the pool `api` instance.
// It talks to the same backend, but the Bearer token / cookie it sends is
// distinct so the two portals can share a browser without cross-auth.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const COLONY_API_BASE = `${BACKEND_URL}/api`;

export const colonyApi = axios.create({
  baseURL: COLONY_API_BASE,
  withCredentials: true, // Sends colony_access_token cookie when present.
  timeout: 60_000,
});

let colonyAuthToken = null;
export const setColonyAuthToken = (token) => { colonyAuthToken = token || null; };

colonyApi.interceptors.request.use((config) => {
  if (colonyAuthToken) config.headers.Authorization = `Bearer ${colonyAuthToken}`;
  return config;
});

// Feedback tracker: rolling log of API calls for bug reports.
installApiLogger(colonyApi);
